var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaceUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8889 6.12889H15.8229C15.308 6.12889 14.8258 5.87378 14.5364 5.44755L12.3509 2.23533C12.0616 1.81066 11.5809 1.55555 11.066 1.55555H4.11111C2.39222 1.55555 1 2.94778 1 4.66666V23.3333C1 25.0522 2.39222 26.4444 4.11111 26.4444H25.8889C27.6078 26.4444 29 25.0522 29 23.3333V9.24C29 7.52266 27.6078 6.12889 25.8889 6.12889Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1846 11.7958V13.6127C13.1846 14.1136 13.5906 14.5196 14.0915 14.5196H15.9083C16.4092 14.5196 16.8152 14.1136 16.8152 13.6127V11.7958C16.8152 11.2949 16.4092 10.8889 15.9083 10.8889H14.0915C13.5906 10.8889 13.1846 11.2949 13.1846 11.7958Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78564 19.054V20.8709C8.78564 21.3718 9.19164 21.7778 9.69253 21.7778H11.5094C12.0103 21.7778 12.4163 21.3718 12.4163 20.8709V19.054C12.4163 18.5531 12.0103 18.1471 11.5094 18.1471H9.69253C9.19164 18.1487 8.78564 18.5531 8.78564 19.054V19.054Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.584 19.054V20.8709C17.584 21.3718 17.99 21.7778 18.4909 21.7778H20.3078C20.8087 21.7778 21.2147 21.3718 21.2147 20.8709V19.054C21.2147 18.5531 20.8087 18.1471 20.3078 18.1471H18.4909C17.99 18.1487 17.584 18.5531 17.584 19.054V19.054Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5824 19.5222H12.418",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.562 18.1533L14.0042 14.4978",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1357 14.4667L18.4691 18.1533",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceUsage);
export default __webpack_public_path__ + "static/media/space-usage.72edcb5e3e08d23e4ab4bdfe2a077cc2.svg";
export { ForwardRef as ReactComponent };